const getThemeColor = (target: string, prefix = 'layout') => {
  const color = getComputedStyle(document.documentElement).getPropertyValue(`--${prefix}-${target}-color`);

  return color.trim();
};

const updateAppVariable = (appTarget: string, layoutTarget: string) => {
  const root = document.documentElement.style;

  const color = getThemeColor(layoutTarget) || getThemeColor(appTarget, 'app');

  root.setProperty(`--app-${appTarget}-color`, color);
};

const updateAppVariables = () => {
  const variables = [
    'primary',
    'dark-primary',
    'light-primary',
    'lighter-primary',
    'secondary',
    'light-secondary',
    'lighter-secondary',
  ];

  variables.forEach((variable) => updateAppVariable(variable, variable));
};

export {
  getThemeColor,
  updateAppVariables,
};
